import{defineMessages}from'react-intl';

export default defineMessages({
applyButtonText:{
id:'i18n.EventFilter.applyButtonText',
defaultMessage:'Apply'},

clearButtonText:{
id:'i18n.EventFilter.clearButtonText',
defaultMessage:'Clear'}});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL0RhdGVQaWNrZXIvRGF0ZVBpY2tlci5tZXNzYWdlcy5qcyJdLCJuYW1lcyI6WyJkZWZpbmVNZXNzYWdlcyIsImFwcGx5QnV0dG9uVGV4dCIsImlkIiwiZGVmYXVsdE1lc3NhZ2UiLCJjbGVhckJ1dHRvblRleHQiXSwibWFwcGluZ3MiOiJBQUFBLE9BQVNBLGNBQVQsS0FBK0IsWUFBL0I7O0FBRUEsY0FBZUEsZ0JBQWU7QUFDNUJDLGdCQUFpQjtBQUNmQyxHQUFJLGtDQURXO0FBRWZDLGVBQWdCLE9BRkQsQ0FEVzs7QUFLNUJDLGdCQUFpQjtBQUNmRixHQUFJLGtDQURXO0FBRWZDLGVBQWdCLE9BRkQsQ0FMVyxDQUFmLENBQWYiLCJmaWxlIjoiRGF0ZVBpY2tlci5tZXNzYWdlcy5qcyIsInNvdXJjZVJvb3QiOiIvYXBwIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgZGVmaW5lTWVzc2FnZXMgfSBmcm9tICdyZWFjdC1pbnRsJztcblxuZXhwb3J0IGRlZmF1bHQgZGVmaW5lTWVzc2FnZXMoe1xuICBhcHBseUJ1dHRvblRleHQ6IHtcbiAgICBpZDogJ2kxOG4uRXZlbnRGaWx0ZXIuYXBwbHlCdXR0b25UZXh0JyxcbiAgICBkZWZhdWx0TWVzc2FnZTogJ0FwcGx5JyxcbiAgfSxcbiAgY2xlYXJCdXR0b25UZXh0OiB7XG4gICAgaWQ6ICdpMThuLkV2ZW50RmlsdGVyLmNsZWFyQnV0dG9uVGV4dCcsXG4gICAgZGVmYXVsdE1lc3NhZ2U6ICdDbGVhcicsXG4gIH0sXG59KTtcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./src/components/DatePicker/DatePicker.messages.js
// module id = 2124
// module chunks = 0